import React from "react";
import Framework from "@beardeddevops/react.framework";
import {Types} from "components";
import {notifyHelpdeskContactedUpdated} from "components/Header/Notifications";

export default class HelpDesksContacted extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Help_Desks_Contacted._name);
		this.state.engineer_contacted = this.getEngineerPkeyFromProps(props);
		this.state.date_contacted = props.date_contacted ?? null;
	}

	getEngineerPkeyFromProps(props = this.props) {
		const currentNote = props.current_note ?? {};
		const pkey = currentNote.engineer_pkey ?? props.engineer_pkey ?? null;
		if (pkey == null || pkey === '') {
			return null;
		}
		const numeric = Number(pkey);
		return Number.isNaN(numeric) ? null : numeric;
	}

	componentDidUpdate() {
		const engineerPkey = this.getEngineerPkeyFromProps(this.props);
		const dateContacted = this.props.date_contacted ?? null;
		const next = {};
		if (engineerPkey != null && Number(engineerPkey) !== Number(this.state.engineer_contacted)) {
			next.engineer_contacted = engineerPkey;
		}
		if (dateContacted != null && dateContacted !== this.state.date_contacted) {
			next.date_contacted = dateContacted;
		}
		if (Object.keys(next).length) {
			this.setState(next);
		}
	}

	async handleSubmit(event, suppressToast = false) {
		const notes = String(this.state.notes ?? '').trim();
		if (!notes) {
			this.setState({notes_error: 'Enter a note for this call.'});
			return false;
		}
		this.state.notes = notes;
		this.state.notes_error = '';
		const engineerPkey = this.getEngineerPkeyFromProps() ?? this.state.engineer_contacted;
		if (engineerPkey != null) {
			this.state.engineer_contacted = Number(engineerPkey);
		}
		const didSubmit = await super.handleSubmit(event, suppressToast);
		if (didSubmit !== false) {
			notifyHelpdeskContactedUpdated(this.state.engineer_contacted);
		}
		return didSubmit;
	}


	form = () => {

		let {properties} = this.model;

		let object = this.state;
		const currentNote = this.props.current_note ?? {};
		return (
			<fieldset>
				<div className={'row'}>
					<div className={'col-12'}>
						<div className="form-group">
							<Framework.Elements.TextField
								property={{...properties.notes, name: 'existing_notes', ignore_validation: true}}
								value={currentNote.notes ?? ''}
								error=""
								update={() => {}}
								multiline={8}
								disabled={true}
								label={'Existing Notes'}
							/>
						</div>
					</div>
					<div className={'col-12'}>
						<div className="form-group">
							<Framework.Elements.TextField
								property={properties.notes}
								value={object.notes}
								error={object.notes_error}
								update={this.handleTextFieldPropertyUpdate}
								multiline={4}
							/>
						</div>
					</div>
				</div>
			</fieldset>
		)
	}
}

